const l = {
  name: "Blog",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.25 5C8.25 5.69 7.69 6.25 7 6.25C6.31 6.25 5.75 5.69 5.75 5C5.75 4.31 6.31 3.75 7 3.75C7.69 3.75 8.25 4.31 8.25 5Z" fill="currentColor"/>
<path d="M11 6.25C11.69 6.25 12.25 5.69 12.25 5C12.25 4.31 11.69 3.75 11 3.75C10.31 3.75 9.75 4.31 9.75 5C9.75 5.69 10.31 6.25 11 6.25Z" fill="currentColor"/>
<path d="M16.25 5C16.25 5.69 15.69 6.25 15 6.25C14.31 6.25 13.75 5.69 13.75 5C13.75 4.31 14.31 3.75 15 3.75C15.69 3.75 16.25 4.31 16.25 5Z" fill="currentColor"/>
<path d="M6 10H18V12H6V10Z" fill="currentColor"/>
<path d="M18 14H6V16H18V14Z" fill="currentColor"/>
<path d="M6 18H11V20H6V18Z" fill="currentColor"/>
<path d="M18 18H13V20H18V18Z" fill="currentColor"/>
<path d="M5 0C3.34772 0 2 1.34772 2 3V21C2 22.6523 3.34772 24 5 24H19C20.6523 24 22 22.6523 22 21V3C22 1.34772 20.6523 0 19 0H5ZM4 3C4 2.45228 4.45228 2 5 2H19C19.5477 2 20 2.45228 20 3V21C20 21.5477 19.5477 22 19 22H5C4.45228 22 4 21.5477 4 21V3Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as Blog
};
